import React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

import {
  ChartData,
  OrgGroupAggregationMetricsData,
  OrgTimeSeriesMetricsData,
} from "../../../../models/ChartCollectionData";
import { DownloadCsvButton } from "../Download";

export interface IOrgChartControlsProps {
  chartIndex: number;
  totalLength: number;
  onClickMoveUp?: () => void;
  onClickMoveDown?: () => void;
  chartDataShown: ChartData;
  chartDetailsData: OrgGroupAggregationMetricsData;
  chartDetailsForLinesData: OrgTimeSeriesMetricsData[];
  prevYearChartDetailsForLinesData: OrgTimeSeriesMetricsData[];
  onClickEditChart: () => void;
  indivFacilityMode?: boolean;
  timeUnit?: "day" | "week" | "month";
}

export const OrgChartControls: React.FunctionComponent<
  IOrgChartControlsProps
> = (props) => {
  const {
    chartIndex,
    totalLength,
    onClickMoveUp,
    onClickMoveDown,
    chartDataShown,
    chartDetailsData,
    chartDetailsForLinesData,
    prevYearChartDetailsForLinesData,
    onClickEditChart,
    indivFacilityMode = false,
    timeUnit,
  } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`analysisCollectionsPage.collectionChartArea.${key}`);

  const [portalElement, setPortalElement] = React.useState<HTMLElement | null>(
    null
  );

  React.useEffect(() => {
    let element = document.getElementById(
      `csv-download-container-${chartDataShown.id}`
    );

    if (!element) {
      element = document.getElementById(`csv-download-${chartDataShown.id}`);
    }

    setPortalElement(element);
  }, [chartDataShown.id]);

  return (
    <div className="top-tools flex-grid">
      <div className="left-drop">
        {!indivFacilityMode && (
          <div className="two-circle">
            <button
              className={`btn icons up-icon ${
                chartIndex === 0 ? "disabled" : ""
              }`}
              onClick={onClickMoveUp}
            >
              &nbsp;
            </button>
            <button
              className={`btn icons down-icon ${
                chartIndex === totalLength - 1 ? "disabled" : ""
              }`}
              onClick={onClickMoveDown}
            >
              &nbsp;
            </button>
          </div>
        )}
        <div className="chart-titles">{chartDataShown.name}</div>
      </div>
      <div className="right-btn">
        {portalElement &&
          createPortal(
            <>
              <DownloadCsvButton
                chartData={chartDataShown}
                chartDetailsData={chartDetailsData}
                chartDetailsDataForLines={chartDetailsForLinesData}
                prevYearChartDetailsDataForLines={
                  prevYearChartDetailsForLinesData
                }
                forWindows={true}
                timeUnit={timeUnit}
              />
              <DownloadCsvButton
                chartData={chartDataShown}
                chartDetailsData={chartDetailsData}
                chartDetailsDataForLines={chartDetailsForLinesData}
                prevYearChartDetailsDataForLines={
                  prevYearChartDetailsForLinesData
                }
                forWindows={false}
                timeUnit={timeUnit}
              />
            </>,
            portalElement
          )}
        <button className="btn btn-border" onClick={onClickEditChart}>
          <i className="icons icon-edit"></i>
          {t("edit")}
        </button>
      </div>
    </div>
  );
};
